import React from "react";
import { Input } from "@headlessui/react";

import { ReactComponent as ArrowNext } from "assets/misc/arrow_right.svg";
import styles from "./TextBox.module.scss";

interface TextBoxProps {
  className?: string;
  value: string;
  onChange: (newValue: string) => void;
  placeholder?: string;
  unfilled?: boolean;
  lean?: boolean;
  password?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  error?: boolean;
  onSubmit?: () => void;
}

const TextBox = ({
  className = "",
  value,
  onChange,
  placeholder = "",
  unfilled = false,
  lean = false,
  password = false,
  disabled = false,
  autoFocus = false,
  error = false,
  onSubmit = undefined,
}: TextBoxProps) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== "Enter" || onSubmit == undefined) {
      return;
    }

    onSubmit();
  };

  return (
    <div className={styles.container}>
      <Input
        className={`${styles.textbox} 
                    ${unfilled && styles.textboxUnfilled}
                    ${lean && styles.textboxLean}
                    ${error && styles.textboxError}  
                    ${className}`}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        type={password ? "password" : "text"}
        disabled={disabled}
        autoFocus={autoFocus}
      />
      {onSubmit !== undefined && (
        <div
          className={`${styles.submitButton} ${lean && styles.lean}`}
          onClick={onSubmit}
        >
          <ArrowNext />
        </div>
      )}
    </div>
  );
};

export default TextBox;
